import React from "react";
import Sidebar from "../../../../component/Navigation/Sidebar/Sidebar";
import LoadingSpinner from "../../../../component/Loading/component";
import addtagicon from "../../../../assests/addtagpayicon.svg";
import addruleicon from "../../../../assests/addruleicon.svg";
import tagdepartmenticon from "../../../../assests/tagdepartmenticon.svg"
import tagpaytagicon from "../../../../assests/tagpaytagicon.svg";
import tagpayruleicon from "../../../../assests/tagpayruleicon.svg"
import tagpayusagelimiticon from "../../../../assests/tagpayusagelimiticon.svg"
import "./TagPayDashboard.css";

const TagPayDashboardComponent = ({
    corporateId,
    corporateName,
    dashboardData,
    loading,
    error,
    onAddTag,
    onAddRule,
    onViewDepartments,
    onViewTags,
    onViewRules,
    onViewUsageLimit,
    onBackClick,
    onRefresh,
    onViewTag  // ✅ Added missing prop
}) => {

    const stats = {
        totalDepartments: dashboardData?.totalDepartments || "",
        totalTags: dashboardData?.totalTags || "",
        totalRules: dashboardData?.totalRules || "",
        usageLimit: dashboardData?.usageLimit || "",
        name: dashboardData?.corporateName || "test"
    };

    if (error) {
        return (
            <div className="tp-dashboard-wrapper">
                <Sidebar />
                <div className="tp-dashboard-main">
                    <div className="tp-error-box">
                        <div className="tp-error-icon">⚠️</div>
                        <h3>Error Loading Dashboard</h3>
                        <p>{error}</p>
                        <button className="tp-retry-btn" onClick={onRefresh}>
                            Try Again
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            {loading ? (
                <LoadingSpinner />
            ) : (
                <div className="tp-dashboard-wrapper">
                    <Sidebar />

                    <div className="tp-dashboard-main">
                        {/* Header */}
                        <div className="tp-header">
                            <button onClick={onBackClick} className="tp-back-btn">
                                ←
                            </button>
                            <h1 className="tp-title">Tag Pay Management</h1>
                        </div>

                        {/* Welcome Section */}
                        <div className="tp-welcome">
                            <h2 className="tp-welcome-title">Welcome, {stats.name}</h2>
                            <p className="tp-welcome-desc">
                                Manage your departments, users, and operational rules from a central overview. Access quick <br /> actions to maintain your workspace efficiently.
                            </p>
                        </div>

                        {/* Stats Row */}
                        <div className="tp-stats-row">
                            <div className="tp-stat-item" onClick={onViewDepartments}>
                                <div className="tp-stat-info">
                                    <span className="tp-stat-label">Departments</span>
                                    <span className="tp-stat-number">{String(stats.totalDepartments).padStart(1, '0')}</span>
                                </div>
                                <div className="tp-stat-icon"> <img src={tagdepartmenticon} alt="" /> </div>
                            </div>

                            {/* ✅ Fixed: Changed onViewTags to onViewTag */}
                            <div className="tp-stat-item" onClick={onViewTag}>
                                <div className="tp-stat-info">
                                    <span className="tp-stat-label">Tags</span>
                                    <span className="tp-stat-number">{String(stats.totalTags).padStart(1, '0')}</span>
                                </div>
                                <div className="tp-stat-icon"><img src={tagpaytagicon} alt="" /></div>
                            </div>

                            <div className="tp-stat-item" onClick={onViewRules}>
                                <div className="tp-stat-info">
                                    <span className="tp-stat-label">Rules</span>
                                    <span className="tp-stat-number">{String(stats.totalRules).padStart(1, '0')}</span>
                                </div>
                                <div className="tp-stat-icon"><img src={tagpayruleicon} alt="" /></div>
                            </div>

                            <div className="tp-stat-item" onClick={onViewUsageLimit}>
                                <div className="tp-stat-info">
                                    <span className="tp-stat-label">Usage Limit</span>
                                    <span className="tp-stat-number">₹ {stats.usageLimit.toLocaleString('en-IN')}</span>
                                </div>
                                <div className="tp-stat-icon"><img src={tagpayusagelimiticon} alt="" /></div>
                            </div>
                        </div>

                        {/* Quick Actions */}
                        <div className="tp-actions">
                            <h3 className="tp-actions-title">Quick Actions</h3>
                            <div className="tp-actions-grid">
                                <button className="tp-action-btn tp-action-primary" onClick={onAddTag}>
                                    <div className="tp-action-icon"><img src={addtagicon} alt="" /></div>
                                    Add Tag
                                </button>

                                <button className="tp-action-btn tp-action-primary" onClick={onAddRule}>
                                    <span className="tp-action-icon"><img src={addruleicon} alt="" /></span>
                                    Add Rule
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default TagPayDashboardComponent;